import Vue from 'vue';
import Vuex from 'vuex';
import userServices from "../services/users";
import ClientServices from "../services/clients";
import FeatureServiceV2 from '../services/V2/FeatureServiceV2';
import CampaignServiceV2 from '../services/V2/CampaignServiceV2';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        welcomeMsg : localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))["firstName"]: "",
        user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')): {},
        logo: localStorage.getItem('logo') ? localStorage.getItem('logo') : "",
        logoInverse: localStorage.getItem('logoInverse') ? localStorage.getItem('logoInverse') : "",
        favicon: localStorage.getItem('favicon') ? localStorage.getItem('favicon') : "",
        isLoggedIn: !!localStorage.getItem('token'),
        usersFilter: localStorage.getItem('usersFilter') ? JSON.parse(localStorage.getItem('usersFilter')) : null,
        packagesFilter: localStorage.getItem('packagesFilter') ? JSON.parse(localStorage.getItem('packagesFilter')) : null,
        ordersFilter: localStorage.getItem('ordersFilter') ? JSON.parse(localStorage.getItem('ordersFilter')) : null,
        features: localStorage.getItem('features') ? JSON.parse(localStorage.getItem('features')) : null,
        adminTools: localStorage.getItem('adminTools') ? JSON.parse(localStorage.getItem('adminTools')) : null,
    },
    getters : {
        isLoggedIn: state => state.isLoggedIn,
        getUser: state => state.user,
        getLogo: state => state.logo,
        getLogoInverse: state => state.logoInverse,
        getFavicon: state => state.favicon,
        getUsersFilter: state => state.usersFilter,
        getPackagesFilter: state => state.packagesFilter,
        getOrdersFilter: state => state.ordersFilter,
        getFeatures: state => state.features,
        getAdminTools: state => state.adminTools,
    },
    actions : {
        login ({ commit }, credentials) {
            commit('login', null);
            const user = userServices.getLogin(credentials)
            .then(async (tokens) => {
                localStorage.setItem('token', tokens.token);
                localStorage.setItem('refreshToken', tokens.refresh_token);
                localStorage.setItem('user', JSON.stringify(tokens.user));
                commit('loginSuccess');

                try {
                    await CampaignServiceV2.checkAdminToolAccess().then((r) => {
                        if (r.status === 204) {
                            localStorage.setItem('adminTools', true);
                        }
                    })
                    .catch((error) => {})
                    .finally(() => {
                        commit('setAdminTools');
                    });

                    const response = await FeatureServiceV2.getClientFeatures(tokens.user.clientId);

                    if (response && response.data && response.data.data) {
                        localStorage.setItem('features', JSON.stringify(response.data.data));
                        commit('setFeatures');
                    }
                } catch (error) {
                    
                }

            })
            .catch(() => {
                error = true;
                commit('loginFailed');
            })
            
            return user;
        },
        loginWithVault ({ commit }, code) {
            commit('login', null);
            return userServices.getLoginVault(code)
                .then(tokens => {
                    localStorage.setItem('token', tokens.token);
                    localStorage.setItem('refreshToken', tokens.refresh_token);
                    localStorage.setItem('user', JSON.stringify(tokens.user));
                    commit('loginSuccess');
                })
                .catch(() => {
                    commit('loginFailed');
                });
        },
        logout ({ commit }) {
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('user');
            localStorage.removeItem('usersFilter');
            localStorage.removeItem('packagesFilter');
            localStorage.removeItem('ordersFilter');
            localStorage.removeItem('features');
            localStorage.removeItem('adminTools');
            commit('logout');
        },
        user ({ commit }, user) {
            commit('user');
            localStorage.setItem('user', JSON.stringify(user));
        },
        setToken ({ commit }, tokens) {
            localStorage.setItem('token', tokens.token);
            localStorage.setItem('refreshToken', tokens.refresh_token);
            commit('loginSuccess');
        },
        logos({ commit }, subdomain) {
            ClientServices.getLogoSubdomain(subdomain).then(logos => {
                if(logos.data.logo) {
                    localStorage.setItem('logo', `${process.env.VUE_APP_CDN_URL}`+logos.data.logo);
                }
                if(logos.data.logoInverse) {
                    localStorage.setItem('logoInverse', `${process.env.VUE_APP_CDN_URL}`+logos.data.logoInverse);
                }
                if(logos.data.favicon) {
                    localStorage.setItem('favicon', `${process.env.VUE_APP_CDN_URL}`+logos.data.favicon);
                }
            });
            commit('logo');
            commit('favicon');
        },
        setUsersFilter({ commit }, filter) {
            localStorage.setItem('usersFilter', JSON.stringify(filter));
            commit('usersFilter');
        },
        clearUsersFilter({ commit }) {
            localStorage.removeItem('usersFilter');
            commit('clearUsersFilter');
        },
        setPackagesFilter({ commit }, filter) {
            localStorage.setItem('packagesFilter', JSON.stringify(filter));
            commit('packagesFilter');
        },
        clearPackagesFilter({ commit }) {
            localStorage.removeItem('packagesFilter');
            commit('clearPackagesFilter');
        },
        setOrdersFilter({ commit }, filter) {
            localStorage.setItem('ordersFilter', JSON.stringify(filter));
            commit('ordersFilter');
        },
        clearOrdersFilter({ commit }) {
            localStorage.removeItem('ordersFilter');
            commit('clearOrdersFilter');
        },
    },
    mutations: {
        login (state) {
            state.pending = true;
        },
        setFeatures(state) {
            state.features = localStorage.getItem('features') ? JSON.parse(localStorage.getItem('features')): {};
        },
        setAdminTools(state) {
            const adminTools = localStorage.getItem('adminTools');
            state.adminTools = adminTools === "true" ? true : false;
            console.log("🚀 ~ setAdminTools ~ state.adminTools:", state.adminTools)
        },
        loginSuccess (state) {
            state.isLoggedIn = true;
            state.user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')): {};
            state.pending = false;
        },
        user (state) {
            state.user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')): {};
        },
        loginFailed (state) {
            state.isLoggedIn = false;
            state.pending = false;
            throw 'Login Failed';
        },
        logout (state) {
            state.user = {};
            state.isLoggedIn = false;
        },
        logo (state) {
            state.logo = localStorage.getItem('logo') ? localStorage.getItem('logo') : "";
        },
        logoInverse (state) {
            state.logoInverse = localStorage.getItem('logoInverse') ? localStorage.getItem('logoInverse') : "";
        },
        favicon (state) {
            state.favicon = localStorage.getItem('favicon') ? localStorage.getItem('favicon') : "";
        },
        usersFilter(state) {
            state.usersFilter = localStorage.getItem('usersFilter') ? JSON.parse(localStorage.getItem('usersFilter')) : null;
        },
        clearUsersFilter(state) {
            state.usersFilter = null;
        },
        packagesFilter(state) {
            state.packagesFilter = localStorage.getItem('packagesFilter') ? JSON.parse(localStorage.getItem('packagesFilter')) : null;
        },
        clearPackagesFilter(state) {
            state.packagesFilter = null;
        },
        ordersFilter(state) {
            state.ordersFilter = localStorage.getItem('ordersFilter') ? JSON.parse(localStorage.getItem('ordersFilter')) : null;
        },
        clearOrdersFilter(state) {
            state.ordersFilter = null;
        }
    },
    modules: {
    },
});

export default store;
